export const INSTALMENT_PAID_TYPE = 'instalment.paid' as const;
export const PROPOSAL_VALIDATED_TYPE = 'proposal.validated' as const;
export const PLAN_ACCOMMODATIONS_SELECTED_TYPE = 'proposal.plan_accommodations_selected' as const;
export const AUTOMATICALLY_SET_LOST_TYPE = 'dossier.automatically_set_lost' as const;

export const allowedNotifications = [
    INSTALMENT_PAID_TYPE,
    PROPOSAL_VALIDATED_TYPE,
    PLAN_ACCOMMODATIONS_SELECTED_TYPE,
    AUTOMATICALLY_SET_LOST_TYPE,
];
